<template>
  <div class="grid gap-y-4 gap-x-5">
    <slot />
  </div>
</template>
